export default (that) => [
  {
    title: that.$l('table_label_predictMonth') || '月份',
    field: 'predictMonth',
    headerAlign: 'center',
    align: 'center',
    minWidth: 80,
  },
  {
    title: that.$l('table_label_avgPrice') || '平均售价',
    field: 'avgPrice',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_saleQty') || '月销量',
    field: 'saleQty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_saleAmount') || '月销售额',
    field: 'saleAmount',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_saleRank') || '小类排名',
    field: 'saleRank',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_advAmount') || '广告花费',
    field: 'advAmount',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_advRatio') || '广销比',
    field: 'advRatio',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    formatter: ({ cellValue }) => cellValue + '%',
  },
  {
    title: that.$l('table_label_inSiteFee') || '站内费用',
    field: 'inSiteFee',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_outSiteFee') || '站外费用',
    field: 'outSiteFee',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_amzReferralFee') || 'Amz推荐费',
    field: 'amzReferralFee',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_fbaFreight') || 'FBA物流费',
    field: 'fbaFreight',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_storageFee') || '仓储',
    field: 'storageFee',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_returnFee') || '退货',
    field: 'returnFee',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_operateProfit') || '平台运营利润',
    field: 'operateProfit',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_operateProfitRatio') || '运营利润率',
    field: 'operateProfitRatio',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    formatter: ({ cellValue }) => cellValue + '%',
  },
  {
    title: that.$l('table_label_goodsCost') || '产品成本',
    field: 'goodsCost',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_monthProfit') || '当月销售利润',
    field: 'monthProfit',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    slots: { default: 'monthProfit' },
  },
  {
    title: that.$l('table_label_monthProfitRatio') || '综合销售利润率',
    field: 'monthProfitRatio',
    headerAlign: 'center',
    align: 'center',
    minWidth: 120,
    slots: { default: 'monthProfitRatio' },
  },
  {
    title: that.$l('table_label_addUpProfit') || '累计销售利润',
    field: 'addUpProfit',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    slots: { default: 'addUpProfit' },
  },
]
